import React from 'react';

import './index.scss';

const BubbleUser = ({ message }) => {
  return (
    <div className="user">
      <div className="user__bubble">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default BubbleUser;
